import cn from 'classnames'
import { useAppDispatch } from "../../effects/useAppDispatch";
import { useAppSelector } from "../../effects/useAppSelector";
import { dmWalCurveActions } from '../../actions/dm-wal-curve.actions';
import { controlPanelActions } from '../../actions';
import { DmWalCurveSecurityState } from '../../types/state/DmWalCurveState';
import { DateTimeStamp } from '../../types/primitives/DateTimeStamp';

interface Props {
    position: DmWalCurveSecurityState
    bwicDate: Date | DateTimeStamp
    children: React.ReactNode;
    onClick?: (isActive: boolean) => void;
}

export function DmWalCurveButton({
    position,
    bwicDate,
    children,
    onClick }: Props) {
    const dispatch = useAppDispatch();
    const dmWalCurveState = useAppSelector(s => s.dmWalCurve);

    const isActive = dmWalCurveState.visible && dmWalCurveState.position?.id === position.id;
    const handleClick = () => {
        if (isActive) {
            dispatch(dmWalCurveActions.hide())
        } else {
            dispatch(controlPanelActions.hide());
            dispatch(dmWalCurveActions.show(position, bwicDate));
        }

        onClick?.(!isActive);
    }


    return (
        <button
            className={cn('pseudo-link', { 'is-active': isActive })}
            onClick={handleClick}
        >
            {children}
        </button>
    );
}